import { useMask } from '@react-input/mask';
import { Input } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

function dateMaskTrack({ inputType, value, data, selectionStart }) {
  if (inputType === 'insert' && selectionStart === 0 && data > 1) {
    return `0${data}`;
  }

  if (inputType === 'insert' && selectionStart === 1 && value[0] == 1 && data > 2) {
    return '2';
  }

  if (inputType === 'insert' && selectionStart === 2 && data > 3) {
    return `0${data}`;
  }

  if (inputType === 'insert' && selectionStart === 4 && value[3] == 3 && data > 1) {
    return '1';
  }

  return data;
}
function MaskInput({ replacement, isFocused, track, showMask, separate, mask, ...props }) {
  const inputRef = useMask({
    replacement,
    track,
    showMask,
    separate,
    mask
  });

  useEffect(() => {
    if (isFocused && inputRef) {
      inputRef.current.focus();
    }
  }, [isFocused, inputRef]);

  return (
    <Input
      ref={inputRef}
      {...props}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          inputRef.current.blur();
        }
      }}
    />
  );
}

MaskInput.propTypes = {
  mask: PropTypes.string
};

export { MaskInput, dateMaskTrack };
